// extracted by mini-css-extract-plugin
export default {"header":"Header_header__9gbAl","nav__desctop":"Header_nav__desctop__anf2H"};